(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('runner', {
            parent: 'entity',
            url: '/runner',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.runner.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/runner/runners.html',
                    controller: 'RunnerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('runner');
                    $translatePartialLoader.addPart('gender');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('runner-detail', {
            parent: 'runner',
            url: '/runner/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.runner.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/runner/runner-detail.html',
                    controller: 'RunnerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('runner');
                    $translatePartialLoader.addPart('gender');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Runner', function($stateParams, Runner) {
                    return Runner.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'runner',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('runner-detail.edit', {
            parent: 'runner-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner/runner-dialog.html',
                    controller: 'RunnerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Runner', function(Runner) {
                            return Runner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('runner.new', {
            parent: 'runner',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner/runner-dialog.html',
                    controller: 'RunnerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                nickname: null,
                                profilePhoto: null,
                                profilePhotoContentType: null,
                                height: null,
                                weight: null,
                                profileText: null,
                                website: null,
                                socialLogin: null,
                                gender: null,
                                birthday: null,
                                mobileDevice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('runner', null, { reload: 'runner' });
                }, function() {
                    $state.go('runner');
                });
            }]
        })
        .state('runner.edit', {
            parent: 'runner',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner/runner-dialog.html',
                    controller: 'RunnerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Runner', function(Runner) {
                            return Runner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('runner', null, { reload: 'runner' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('runner.delete', {
            parent: 'runner',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/runner/runner-delete-dialog.html',
                    controller: 'RunnerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Runner', function(Runner) {
                            return Runner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('runner', null, { reload: 'runner' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
